import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Config } from '../../config/config';
import { VnptHttpService } from '../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { ResetPassword } from './reset-password';

@Injectable()
export class ResetPasswordService {

    constructor(private http: VnptHttpService) { }

    resetPassword(item:ResetPassword){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        return this.http.post(Config.apiUrl + 'account/ResetPassword', item, {headers: headers}).map(resp=>resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/reset-password/reset-password.service.ts